module.exports = __webpack_public_path__ + "img/info-01.dcba242d.jpg";